import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from './../../../../themes/default';
import ThemeCustom from './../../../../themes/custom';

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing.unit
  },
  bullet: {
    width: theme.spacing.unit * 3,
    height: theme.spacing.unit * 1.2,
    borderRadius: theme.spacing.unit
  },
  stats: {
    flex: 1,
    paddingLeft: theme.spacing.unit,
    fontSize: 12
  },
  disableGutters: {
    marginBottom: 0
  },
  primary: {
    color: theme.palette.primary.contrastText,
    background: theme.palette.primary.main,
    '&:hover': {
      background: theme.palette.primary.dark
    }
  },
  secondary: {
    color: theme.palette.secondary.contrastText,
    background: theme.palette.secondary.main,
    '&:hover': {
      background: theme.palette.secondary.dark
    }
  },
  success: {
    color: ThemeCustom.palette.success.contrastText,
    background: ThemeCustom.palette.success.main,
    '&:hover': {
      background: ThemeCustom.palette.success.dark
    }
  },
  info: {
    color: ThemeCustom.palette.info.contrastText,
    background: ThemeCustom.palette.info.main,
    '&:hover': {
      background: ThemeCustom.palette.info.dark
    }
  },
  warning: {
    color: ThemeCustom.palette.warning.contrastText,
    background: ThemeCustom.palette.warning.main,
    '&:hover': {
      background: ThemeCustom.palette.warning.dark
    }
  },
  danger: {
    color: ThemeCustom.palette.danger.contrastText,
    background: ThemeCustom.palette.danger.main,
    '&:hover': {
      background: ThemeCustom.palette.danger.dark
    }
  }
});

const Legend = ({ text, variant, classes, disableGutters }) => {

  const _variant = variant ? classes[variant] : null;

  return (
    <div className={ classNames(classes.root, disableGutters ? classes.disableGutters : null ) }>
      <span className={ classNames(_variant, classes.bullet ) }></span>
      <span className={ classNames(classes.stats ) }>
        { text }
      </span>
    </div>
  )

}

Legend.propTypes = {
  text: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary', 'success', 'info', 'warning', 'danger'])
};

export default withStyles(styles)(Legend);
